import { render } from "./ExportJSON.vue?vue&type=template&id=54705363&scoped=true&ts=true"
import script from "./ExportJSON.vue?vue&type=script&lang=ts"
export * from "./ExportJSON.vue?vue&type=script&lang=ts"

import "./ExportJSON.vue?vue&type=style&index=0&id=54705363&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54705363"]])

export default __exports__